const date = [
  {
    id: '0',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Sootballs',
    info: 'Kamadzi\'s assistants in the boiler room of the Aburaya baths.',
    img: '0_1',
    game: false,
  },
  {
    id: '1',
    anime: 'Spirited Away',
    year: '2001',
    name: 'No-Face',
    info: 'A deity that does not have its own face and wanders in search of a new one. Thanks to Chihiro, he was able to enter the Abura-Ya Bath, where he absorbed three spirits before being exposed as a werewolf spirit. Subsequently, he stayed to help with the household of Dzenibe.',
    img: '0_2',
    game: true,
  },
  {
    id: '2',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Boh',
    info: 'Yubaba\'s son. Terribly spoiled and capricious. Before meeting Chihiro, he never left his room due to his mother\'s fear of all kinds of infections. Several times larger than his mother. Zeniba turned him into a hamster, and in this form he went on a journey with Chihiro, and changed a lot during his time.',
    img: '0_3',
    game: false,
  },
  {
    id: '3',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Kamaji',
    info: 'The six-armed "hearth keeper" of the Yubaba baths, leading the team of Susuvatari. He spends almost all his time at work - he even eats and sleeps, without leaving the workplace. To some extent, he morally opposes Yubaba, deceiving the worker Rin, saying that she is his granddaughter. All the workers of the baths of Abura-ya adored the old man and called him simply grandfather.',
    img: '0_4',
    game: true,
  },
  {
    id: '4',
    anime: 'Spirited Away',
    year: '2001',
    name: 'River Spirit',
    info: 'The spirit of the rivers, originally mistaken for the Spirit of Dumpsters in the Abura-ya baths due to the extreme degree of filth. Helped Chihiro, thanking her for her work with nigadango (healing "bitter cake").',
    img: '0_5',
    game: true,
  },
  {
    id: '5',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Lin',
    info: 'Chihiro\'s mentor, works at the Yubaba Baths. The grumpy but good-natured and charming spirit of a white fox in human form.',
    img: '0_6',
    game: false,
  },
  {
    id: '6',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Chihiro Ogino',
    info: 'The most ordinary ten-year-old girl, the main character of the film. On the way to the new city, together with her parents, she was on the side of the spirits. The parents tasted Yubaba\'s food and ended up being turned into pigs, which forced Chihiro to go into Yubaba\'s service. As a result of the contract with Yubaba, she receives the name Sen in exchange for her own Chihiro.',
    img: '0_7',
    game: false,
  },
  {
    id: '7',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Haku',
    info: 'Disciple of Yubaba, dragon, guardian of the Kohakugawa River in human form. Chihiro\'s friend.',
    img: '0_8',
    game: false,
  },
  {
    id: '8',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Yubaba',
    info: 'The mistress of the place - the Abura-Ya baths, where Chihiro, the teacher of Haku, fell. A terrible sorceress who does not throw words to the wind, does not like to be contradicted, but always keeps her promises. He keeps everyone in his iron mitts, except for his own son, whom he terribly pampers.',
    img: '0_9',
    game: false,
  },
  {
    id: '9',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Kashira',
    info: 'A trio of brothers with only heads. They are constantly in Yubaba\'s office. Have been transformed by Zeniba into Bo\'s doppelganger.',
    img: '0_10',
    game: false,
  },
  // следующее аниме
  {
    id: '10',
    anime: 'Princess Mononoke',
    year: '1997',
    name: 'Ashitaka',
    info: 'The main character. Young prince of the Amisi tribe. Becomes a victim of the curse. Performs the ceremony of cutting hair and leaves the village to the west in search of what caused the beast to be consumed by hatred. He has an exclusive command of weapons, but at the same time he is looking for a way to do without violence. Loves San.',
    img: '1_1',
    game: false,
  },
  {
    id: '11',
    anime: 'Princess Mononoke',
    year: '1997',
    name: 'Gonza',
    info: 'Assistant to the Lady. Rude, often screaming, strongly devoted and attached to the Lady.',
    img: '1_2',
    game: false,
  },
  {
    id: '12',
    anime: 'Princess Mononoke',
    year: '1997',
    name: 'Lady Eboshi',
    info: 'The head of the "iron" town. Domineering, smart, she will stop at nothing to achieve her goals. But she is not as cruel as it seems at the beginning, even despite her hatred of the inhabitants of the magic forest. Shooting a forest spirit, he loses his hand. Soon he realizes that the spirit of the forest can give and take away life, and decides to live in peace.',
    img: '1_3',
    game: false,
  },
  {
    id: '13',
    anime: 'Princess Mononoke',
    year: '1997',
    name: 'Ji-san',
    info: 'A sentry in the village of Amisi. Warns Asitaka about the appearance of the cursed boar.',
    img: '1_4',
    game: false,
  },
  {
    id: '14',
    anime: 'Princess Mononoke',
    year: '1997',
    name: 'Jigo',
    info: 'A Buddhist monk who cleverly manipulates people and events for his own benefit. Helps Eboshi kill the Deer God, counting on the Emperor\'s reward. He tries to shift all the dirty work (like murder) onto the shoulders of others.',
    img: '1_5',
    game: false,
  },
  {
    id: '15',
    anime: 'Princess Mononoke',
    year: '1997',
    name: 'Kaya',
    info: 'Girl from Emishi village, friend of Asitaka. She was engaged to him before his exile. I gave Asitaka my dagger as a keepsake.',
    img: '1_6',
    game: false,
  },
  {
    id: '16',
    anime: 'Princess Mononoke',
    year: '1997',
    name: 'Kodama',
    info: 'Spirits of the forest. They are a sign that the Forest is healthy.',
    img: '1_7',
    game: false,
  },
  {
    id: '17',
    anime: 'Princess Mononoke',
    year: '1997',
    name: 'Forest Spirit',
    info: 'The god of the forest in the form of a deer. Grants life and death. His blood can cure any disease, and his head bestows immortality. At night it becomes a huge spirit, which people call the Night Wanderer, and at dawn - a deer with several dozen antlers.',
    img: '1_8',
    game: false,
  },
  {
    id: '18',
    anime: 'Princess Mononoke',
    year: '1997',
    name: 'Moro',
    info: 'She-wolf goddess, adoptive mother of San. He tries to keep the inhabitants of the Forest from fighting, although they do not agree - they prefer death in a battle "which people will never forget" to the slow extinction and degradation of their kind. Dies saving Sun.',
    img: '1_9',
    game: false,
  },
  {
    id: '19',
    anime: 'Princess Mononoke',
    year: '1997',
    name: 'San (Princess Mononoke)',
    info: 'Main character. In early childhood, she was abandoned by her parents and raised by the Wolf Goddess. I am ready to give my life for my forest and its inhabitants. People (with the exception of Asitaka) are treated with contempt and hatred.',
    img: '1_10',
    game: false,
  },
  // следующее аниме
  {
    id: '20',
    anime: 'Nausicaä of the Valley of the Wind',
    year: '1984',
    name: 'Asbel',
    info: 'Prince of the Physites (City of Pagitei), noble youth, brother of Lastel. He destroyed almost the entire fleet of Princess Xiana (Kushana), but later his fighter was shot down.',
    img: '2_1',
    game: false,
  },
  {
    id: '21',
    anime: 'Nausicaä of the Valley of the Wind',
    year: '1984',
    name: 'King Jihl',
    info: 'Father Nausicaa, ruler of the Valley of the Winds. In the past, he was a wise ruler and a brave warrior, but poisoning with mushroom spores has long been bedridden. Killed by the Tolmekites (in the anime version). In the manga, he died a natural death.',
    img: '2_2',
    game: false,
  },
  {
    id: '22',
    anime: 'Nausicaä of the Valley of the Wind',
    year: '1984',
    name: 'Kushana',
    info: 'Commander of the Tolmek military corps. In the anime, he wants to burn the Forest and believes that a person should be the "master of everything." She lacks both legs and one arm.',
    img: '2_3',
    game: false,
  },
  {
    id: '23',
    anime: 'Nausicaä of the Valley of the Wind',
    year: '1984',
    name: 'Kurotowa',
    info: 'Xiana\'s closest friend. A talented corvette pilot and visionary strategist. In the manga, an infiltrator sent to provoke Xiana into mutiny, but defected to her side.',
    img: '2_4',
    game: false,
  },
  {
    id: '24',
    anime: 'Nausicaä of the Valley of the Wind',
    year: '1984',
    name: 'Lastelle',
    info: 'Physite Princess (Pagitei City). She was captured by the Tolmekians, who hoped to find out from her the secret of controlling the Titan. During the crash of the Tolmek aircraft on the outskirts of the Valley of the Winds, she was seriously wounded and died in the arms of Nausicaa. Before she died, she asked to destroy the Titan.',
    img: '2_5',
    game: false,
  },
  {
    id: '25',
    anime: 'Nausicaä of the Valley of the Wind',
    year: '1984',
    name: 'Mito',
    info: 'Chief of the guards in the palace of Prince Jil. He loves Nausicaa very much and always tries to protect her.',
    img: '2_6',
    game: false,
  },
  {
    id: '26',
    anime: 'Nausicaä of the Valley of the Wind',
    year: '1984',
    name: 'Nausicaa',
    info: 'The main character, the princess of the Valley of the Winds. She managed to solve the secret of the Forest and tell others about it. Later he becomes Cloaked in blue.',
    img: '2_7',
    game: false,
  },
  {
    id: '27',
    anime: 'Nausicaä of the Valley of the Wind',
    year: '1984',
    name: 'Obaba Hisako',
    info: 'The old blind woman, the sage of the Valley. Heralds the appearance of the Blue Wrapped One.',
    img: '2_8',
    game: false,
  },
  {
    id: '28',
    anime: 'Nausicaä of the Valley of the Wind',
    year: '1984',
    name: 'Ohmu',
    info: 'Giant insects of the Forest. In a calm state, their eyes are blue, in rage they turn red. They are considered enemies of people until Nausicaa shows their downside.',
    img: '2_9',
    game: false,
  },
  {
    id: '29',
    anime: 'Nausicaä of the Valley of the Wind',
    year: '1984',
    name: 'Teto',
    info: 'Squirrel fox, animal and friend of Nausicaa. It was brought by Yupa to the Valley.',
    img: '2_10',
    game: false,
  },
  // другое аниме
  {
    id: '30',
    anime: 'The Wind Rises',
    year: '2013',
    name: 'Giovanni Battista Caproni',
    info: 'Famous Italian aircraft designer, founder of Caproni. For many years, he appears in Jiro\'s visions and guides the boy on the path of dreams. Also talks about his successes and failures.',
    img: '3_1',
    game: false,
  },
  {
    id: '31',
    anime: 'The Wind Rises',
    year: '2013',
    name: 'Jiro Horikoshi',
    info: 'At the beginning, he is represented as a boy who dreams of piloting an airplane, but cannot do this, as he suffers from myopia. Once in his dream he sees Gianni Caproni, who invites the boy to become an aircraft builder. Since then, Jiro has faithfully followed his dream and, at the age of 23, got a job as an engineer in the internal combustion engine division of Mitsubishi. At first, many of Jiro\'s projects are unsuccessful, but in the end he develops the Mitsubishi A6M Zero, which will be used in the future during the Second World War. Calm and discreet person. He does not share the ideals of Japanese nationalism, but only follows his old dream - to create airplanes.',
    img: '3_2',
    game: false,
  },
  {
    id: '32',
    anime: 'The Wind Rises',
    year: '2013',
    name: 'Kayo Horikoshi',
    info: 'Jiro\'s younger sister. A very energetic and ardent girl who loves to scold Jiro for not fulfilling her duties. When she grows up, she decides to become a doctor and treats Naoko, later becoming her best friend. Speaks out categorically against Naoko straining herself and going outside. At the end, he sees Naoko running away.',
    img: '3_3',
    game: false,
  },
  {
    id: '33',
    anime: 'The Wind Rises',
    year: '2013',
    name: 'Castorp',
    info: 'A German who came to live in Japan temporarily. At the restaurant, he often enters into dialogue with Jiro and warned him about the impending war. Confronted against the Nazis.',
    img: '3_4',
    game: false,
  },
  {
    id: '34',
    anime: 'The Wind Rises',
    year: '2013',
    name: 'Kinu',
    info: 'A friend of Jiro and Satomi. He first meets Jiro on the train on the day of the earthquake on September 1.',
    img: '3_5',
    game: false,
  },
  {
    id: '35',
    anime: 'The Wind Rises',
    year: '2013',
    name: 'Honjo',
    info: 'Jiro\'s best friend, aircraft designer. An ardent and ambitious person, but just as talented as Jiro. At first, his designs were even better than Jiro\'s.',
    img: '3_6',
    game: false,
  },
  {
    id: '36',
    anime: 'The Wind Rises',
    year: '2013',
    name: 'Mr. Kurokawa',
    info: 'Начальник подразделения компании «Мицубиси», коротышка. Очень амбициозен, всегда нервничает, воспринимает всё слишком эмоционально и находится на грани истерики. Быстро оценивает талант Дзиро и доверяет ему серьёзные проекты. Выступал свидетелем во время брака Дзиро и Наоко.',
    img: '3_7',
    game: false,
  },
  {
    id: '37',
    anime: 'The Wind Rises',
    year: '2013',
    name: 'Mrs. Kurokawa',
    info: 'Mr. Kurokawa\'s wife. Allows Naoko and Jiro to stay in the house, helping Naoko get ready for the wedding. Very happy for Jiro and Naoko and very worried about Naoko\'s illness. Stops Kayo, allowing Naoko to escape.',
    img: '3_8',
    game: false,
  },
  {
    id: '38',
    anime: 'The Wind Rises',
    year: '2013',
    name: 'Naoko Satomi',
    info: 'Jiro Horikoshi\'s wife. She first met Jiro as a teenager, on the day of the earthquake on September 1, when Jiro helped her find a family, but then her family\'s estate was completely burned down. For a long time she did not meet with Jiro, but during this time her mother died of tuberculosis, and Naoko herself became infected with the disease. While sketching the landscape, she met Jiro by chance and then began dating him. Jiro answered her with mutual love, they decided to get married, having received a blessing from their parents. However, Naoko\'s illness began to progress, and then Jiro and Naoko decided to prematurely marry with only two witnesses and spent the rest of the time next to each other.',
    img: '3_9',
    game: false,
  },
  {
    id: '39',
    anime: 'The Wind Rises',
    year: '2013',
    name: 'Satomi',
    info: 'Naoko\'s father. A benevolent person, treats Jiro well. He blessed Jiro and his daughter to marry.',
    img: '3_10',
    game: false,
  },
  // другое аниме
  {
    id: '40',
    anime: 'My Neighbor Totoro',
    year: '1988',
    name: 'Granny',
    info: 'An elderly and very kind neighbor of Satsuki and Mei. Helps to settle in a new house and tells the girls about susuvatari.',
    img: '4_1',
    game: false,
  },
  {
    id: '41',
    anime: 'My Neighbor Totoro',
    year: '1988',
    name: 'Kanta Ogaki',
    info: 'Neighborhood eleven-year-old boy. Satsuki and Mei helped out by giving them his umbrella when it was raining heavily, but he himself ran home light and got wet to the skin. Later a friend of Satsuki.',
    img: '4_2',
    game: false,
  },
  {
    id: '42',
    anime: 'My Neighbor Totoro',
    year: '1988',
    name: 'Catbus / Nekobasu',
    info: 'Huge cat bus. It has a very informative sign showing where and to whom you need to go. It moves with great speed, inside it does not look like a living creature, although the seats are covered with fur and can rise at the request of the cat. He sees in the dark, emitting rays of light from his eyes. Signal lights are rats with glowing eyes. It is invisible to most people: when the Catbus passes by, they feel only a sudden gust of wind.',
    img: '4_3',
    game: false,
  },
  {
    id: '43',
    anime: 'My Neighbor Totoro',
    year: '1988',
    name: 'Michiko',
    info: 'Satsuki\'s friend at the new school.',
    img: '4_4',
    game: false,
  },
  {
    id: '44',
    anime: 'My Neighbor Totoro',
    year: '1988',
    name: 'Mei Kusakabe',
    info: 'The main character, the four-year-old younger sister of Satsuki. Stubborn and touchy. He often quarrels with the Setra, but loves her very much and everywhere tries to follow and keep up with her. The first to meet Totoro.',
    img: '4_5',
    game: false,
  },
  {
    id: '45',
    anime: 'My Neighbor Totoro',
    year: '1988',
    name: 'Otoko',
    info: 'A man on a tractor that Satsuki met when she was looking for her sister Mei.',
    img: '4_6',
    game: false,
  },
  {
    id: '46',
    anime: 'My Neighbor Totoro',
    year: '1988',
    name: 'Satsuki Kusakabe',
    info: 'The main character is May\'s eleven-year-old older sister. She is very responsible, takes care of her sister and father, helps him when moving, prepares food. She behaves like an adult, as she had to take on a lot due to her mother\'s illness.',
    img: '4_7',
    game: false,
  },
  {
    id: '47',
    anime: 'My Neighbor Totoro',
    year: '1988',
    name: 'Sootballs',
    info: 'Black nigella, wandering soot - little black fluffy creatures. They live in abandoned houses and do no harm. When a person appears in the house, they move to another place.',
    img: '4_8',
    game: false,
  },
  {
    id: '48',
    anime: 'My Neighbor Totoro',
    year: '1988',
    name: 'Tatsuo Kusakabe',
    info: 'Yasuko\'s husband and Mei and Satsuki\'s father. Calm and reasonable person. Works as a professor at the college.',
    img: '4_9',
    game: false,
  },
  {
    id: '49',
    anime: 'My Neighbor Totoro',
    year: '1988',
    name: 'King Totoro',
    info: 'Guardian of the forest, a large furry creature of gray color. Can\'t speak, makes only chest growling sounds. He is depicted as a kind and sweet character, but there are hints in the film that if he gets angry, big trouble can happen.',
    img: '4_10',
    game: false,
  },
  // другое аниме
  {
    id: '50',
    anime: 'Kiki\'s Delivery Service',
    year: '1989',
    name: 'Osono',
    info: 'The owner of a small bakery in the town of Koriko where Kiki is staying. She is pregnant. The first in the city to show attention to Kiki and treat her with kindness. Supported Kiki\'s idea to start working as a small parcel delivery woman, provided a room and a telephone, gave her a part-time job in her bakery, and taught her the basics of doing business.',
    img: '5_1',
    game: false,
  },
  {
    id: '51',
    anime: 'Kiki\'s Delivery Service',
    year: '1989',
    name: 'Barsa',
    info: 'Manager of Oku-sama\'s house, Oku-sama\'s companion.',
    img: '5_2',
    game: false,
  },
  {
    id: '52',
    anime: 'Kiki\'s Delivery Service',
    year: '1989',
    name: 'Fukuo',
    info: 'Asona\'s husband. Tall, physically strong, laconic. Kindness and care is expressed by actions, not words.',
    img: '5_3',
    game: false,
  },
  {
    id: '53',
    anime: 'Kiki\'s Delivery Service',
    year: '1989',
    name: 'Jiji',
    info: 'Black cat, friend of Kiki. Cautious, not devoid of sarcasm and irony.',
    img: '5_4',
    game: false,
  },
  {
    id: '54',
    anime: 'Kiki\'s Delivery Service',
    year: '1989',
    name: 'Kiki',
    info: 'Main character. Thirteen-year-old girl, apprentice witch. Leaves home to complete a year of practice. Of all the magical skills, she mastered only flying on a broomstick and talking with the magic cat Zizi. Energetic, benevolent, hardworking. He doors people without checking, follows his feelings and feelings of happiness.',
    img: '5_5',
    game: false,
  },
  {
    id: '55',
    anime: 'Kiki\'s Delivery Service',
    year: '1989',
    name: 'Kokiri',
    info: 'Kiki\'s mom. A witch preparing magical herbal infusions for the treatment of many diseases in Kiki\'s hometown. She worries that Kiki is not serious enough and trained enough to successfully complete her internship.',
    img: '5_6',
    game: false,
  },
  {
    id: '56',
    anime: 'Kiki\'s Delivery Service',
    year: '1989',
    name: 'Maki',
    info: 'Kiki\'s neighbor and first customer, the owner of the cat Lily, is a successful fashion designer. Kiki is jealous of her during the stagnation in business.',
    img: '5_7',
    game: false,
  },
  {
    id: '57',
    anime: 'Kiki\'s Delivery Service',
    year: '1989',
    name: 'Okino',
    info: 'Kiki\'s father and Kokiri\'s husband. A professor who studies stories and customs associated with witches. He is not from a witch family and does not have magical abilities, he met Kiki\'s mother in his youth, when she flew to the town for an internship.',
    img: '5_8',
    game: false,
  },
  {
    id: '58',
    anime: 'Kiki\'s Delivery Service',
    year: '1989',
    name: 'Tombo Kopoli',
    info: 'A fourteen year old boy who lives in the city that Kiki has chosen for her practice. Kiki\'s friend.',
    img: '5_9',
    game: false,
  },
  {
    id: '59',
    anime: 'Kiki\'s Delivery Service',
    year: '1989',
    name: 'Ursula',
    info: 'Young artist, about 18-19 years old. Becomes an older sister for Kiki. Lives in the summer in the forest, in a small house in the suburb of Koriko.',
    img: '5_10',
    game: false,
  },
  // другое аниме
  {
    id: '60',
    anime: 'Castle in the Sky',
    year: '1986',
    name: 'General Muoro',
    info: 'A warlord looking for Laputa. He hates Musku and tries in every possible way to take him under his control, but he does not succeed. Killed at the hands of Muska while falling from Laputa together with his soldiers.',
    img: '6_1',
    game: false,
  },
  {
    id: '61',
    anime: 'Castle in the Sky',
    year: '1986',
    name: 'Henry',
    info: 'Dora\'s son and brother to Louis and Charlie. Air pirate.',
    img: '6_2',
    game: false,
  },
  {
    id: '62',
    anime: 'Castle in the Sky',
    year: '1986',
    name: 'Duffi',
    info: 'Okami\'s husband and Madge\'s father. Chief Pazu.',
    img: '6_3',
    game: false,
  },
  {
    id: '63',
    anime: 'Castle in the Sky',
    year: '1986',
    name: 'Dola',
    info: 'A harsh and rude woman, the leader of the "sky" pirate clan. He keeps his sons in an iron fist, who are members of her gang and obey her in every possible way. Despite her rude calculating nature and obvious lack of culture, she is a rather kind woman, although she hides it in every possible way.',
    img: '6_4',
    game: false,
  },
  {
    id: '64',
    anime: 'Castle in the Sky',
    year: '1986',
    name: 'Uncle Pom',
    info: 'An old miner and miner, spent most of his life underground. Helps Paz and Sita get out of the abandoned mines. Tells them about the flying stone.',
    img: '6_5',
    game: false,
  },
  {
    id: '65',
    anime: 'Castle in the Sky',
    year: '1986',
    name: 'Louis',
    info: 'Dora\'s second son and Charlie\'s brother. Air pirate.',
    img: '6_6',
    game: false,
  },
  {
    id: '66',
    anime: 'Castle in the Sky',
    year: '1986',
    name: 'Pazu',
    info: 'The main character. Sita\'s age, orphan, assistant to the master of the miner\'s furnace. She dreams of finding Laputa. Caught Sita unconscious above the mine and took care of her. Brave, strong is distinguished by increased "strength" of the head, dexterity, determination and dexterity.',
    img: '6_7',
    game: false,
  },
  {
    id: '67',
    anime: 'Castle in the Sky',
    year: '1986',
    name: 'Colonel Muska (Romuska Palo Ur Laputa)',
    info: 'A government agent wishing to become King of Laputa. He is indifferent to the military and in every possible way makes him angry and despises the narrow-minded commander of the military. She dreams of taking possession of high technology and the legendary weapon of Laputa, and, accordingly, seizing power on Earth.',
    img: '6_8',
    game: false,
  },
  {
    id: '68',
    anime: 'Castle in the Sky',
    year: '1986',
    name: 'Princess Lusheeta Sheeta Toel Ur Laputa',
    info: 'Main character. A shepherd girl from a mountain village, orphaned early and inherited the crystal of the Flying Stone. At the end of the film, he says, together with Pazu, the words of Laputa\'s destruction, thus escaping from Muska and protecting peace on Earth.',
    img: '6_9',
    game: false,
  },
  {
    id: '69',
    anime: 'Castle in the Sky',
    year: '1986',
    name: 'Charlie',
    info: 'Dora\'s son and Louis\' brother. Air pirate.',
    img: '6_10',
    game: false,
  },
  // другое аниме
  {
    id: '70',
    anime: 'Ponyo',
    year: '2008',
    name: 'Yoshie',
    info: 'One of the older women in the senior day care center.',
    img: '7_1',
    game: false,
  },
  {
    id: '71',
    anime: 'Ponyo',
    year: '2008',
    name: 'Kumiko',
    info: 'A five-year-old girl, a friend of Soosuke.',
    img: '7_2',
    game: false,
  },
  {
    id: '72',
    anime: 'Ponyo',
    year: '2008',
    name: 'Karen',
    info: 'A five-year-old girl, classmate of Sooske.',
    img: '7_3',
    game: false,
  },
  {
    id: '73',
    anime: 'Ponyo',
    year: '2008',
    name: 'Koichi',
    info: 'Soosuke\'s father, Risa\'s husband. Fishing trawler captain. Probably spends most of the time at sea and is rarely at home.',
    img: '7_4',
    game: false,
  },
  {
    id: '74',
    anime: 'Ponyo',
    year: '2008',
    name: 'Granmamare',
    info: 'Mother of Ponyo and her sisters, spirit of the sea. A very kind woman. Unlike Fujimoto, she is not opposed to Ponyo becoming human, claiming that it is her choice.',
    img: '7_5',
    game: false,
  },
  {
    id: '75',
    anime: 'Ponyo',
    year: '2008',
    name: 'Noriko',
    info: 'One of the older women in the senior day care center.',
    img: '7_6',
    game: false,
  },
  {
    id: '76',
    anime: 'Ponyo',
    year: '2008',
    name: 'Ponyo (Brunhilde)',
    info: 'Main character. A small red goldfish, the daughter of a powerful sorcerer and sea goddess. According to one of the old women, it is a mermaid fish and can cause hurricanes. After he tastes Soosuke\'s blood, he gains the ability to transform into a human and after that becomes strongly attached to Soosuke, but if the boy refuses Ponyo, it will turn into sea foam. Knows how to conjure. The use of magic apparently drains her powers - she suddenly falls asleep and is difficult to wake up.',
    img: '7_7',
    game: false,
  },
  {
    id: '77',
    anime: 'Ponyo',
    year: '2008',
    name: 'Lisa',
    info: 'Soosuke\'s mother. Works as a senior manager of a day care center for the elderly. Kind and cheerful, she does not lose her presence of mind in case of danger. Somewhat impulsive, can sometimes flare up.',
    img: '7_8',
    game: false,
  },
  {
    id: '78',
    anime: 'Ponyo',
    year: '2008',
    name: 'Sosuke',
    info: 'The main character. A five-year-old boy, lives with his mother in a cozy house on a cliff. Responsible and honest. I found Ponyo on the seashore not far from the house and immediately became friends with her. Knows Morse code, exchanges messages with his father using an optical telegraph.',
    img: '7_9',
    game: false,
  },
  {
    id: '79',
    anime: 'Ponyo',
    year: '2008',
    name: 'Fujimoto',
    info: 'Father Ponyo, grumpy, but not evil sorcerer. It often raises a panic, is emotional. He takes care of Ponyo and his other daughters and is kind to their mother. She dreams of returning to the planet the Era of the Sea, which passed many years ago (namely, to cleanse the sea polluted by people) with the help of "living water".',
    img: '9_10',
    game: false,
  },
  // новое аниме
  {
    id: '80',
    anime: 'Future Boy Conan',
    year: '1978',
    name: 'Conan',
    info: 'The main protagonist of the series, Conan, is an 11 year old boy who grew up on the island and was raised by his grandfather. Conan is very strong, and can even hang from a ledge using only his toes. Conan is friends with Lana.',
    img: '8_1',
    game: false,
  },
  {
    id: '81',
    anime: 'Future Boy Conan',
    year: '1978',
    name: 'Lana',
    info: 'Lana is the first non-Remnant Island inhabitant, and the first girl Conan sees. Lana is the granddaughter of Dr. Lao, and Lepka wants to use her to get Lao to tell him the secret of solar power. Lana is referred to as possessing ESP, allowing her to communicate with a tern named Tikki, as well as sense the presence of her grandpa. She comes from High Harbour.',
    img: '8_2',
    game: false,
  },
  {
    id: '82',
    anime: 'Future Boy Conan',
    year: '1978',
    name: 'Grandpa',
    info: 'Conan\'s elderly grandfather, who\'s alive after their spaceship crashes on the remnant island in the first episode.',
    img: '8_3',
    game: false,
  },
  {
    id: '83',
    anime: 'Future Boy Conan',
    year: '1978',
    name: 'Monsley',
    info: 'A young commander of Industria\'s armed forces, Monsley is the second non-Islander Conan sees. Piloting the flying boat Falco, she follows Lepka\'s orders by helping capture Lana, and eventually leading the invasion of Industria to conquer the High Habor. Ultimately after the lost battle in the High Harbor, Monsley renounces Lepka\'s ambitions, and joins with Conan against him.',
    img: '8_4',
    game: false,
  },
  {
    id: '84',
    anime: 'Future Boy Conan',
    year: '1978',
    name: 'Jimsy',
    info: 'A wild boy living alone on the first island Conan arrives at, Jimsy quickly becomes Conan\'s first \'companion\', helping him rescue Lana. Jimsy is a master hunter, and motivated by his stomach.',
    img: '8_5',
    game: false,
  },
  {
    id: '85',
    anime: 'Future Boy Conan',
    year: '1978',
    name: 'Dyce',
    info: 'Dyce is a citizen of Industria, and the captain of the ship Barracuda. He was ordered to kidnap Lana prior to the start of series, but let her escape due to his obsession with his captive. Dyce is initially a comedic villain in the show, but eventually becomes one of Conan\'s allies. Orlo calls him "Uncle", a nickname he dislikes.',
    img: '8_6',
    game: false,
  },
  {
    id: '86',
    anime: 'Future Boy Conan',
    year: '1978',
    name: 'Lepka',
    info: 'The head of administration of Industria, Lepka technically serves under the Industria High Council, a group of scientists. However, over the course of the series, he becomes the sole dictator of Industria, and the primary antagonist. Lepka desires to extract the secret of solar power from Lao to power his weapons, allowing him to rule over what remains of the world.',
    img: '8_7',
    game: false,
  },
  {
    id: '87',
    anime: 'Future Boy Conan',
    year: '1978',
    name: 'Dr. Lao',
    info: 'The grandfather of Lana, the main scientist responsible for the development of solar power for both civil and wartime usage. Originally a member of the Industrian High Council, he defected after he learned of Lepka\'s ambitions. He believes that the people of Industria must be taught to discard their weapons, and begin new lives. For this reason he escapes, bringing with him the secret of how to access the orbiting solar power station from pre-war times.',
    img: '8_8',
    game: false,
  },
  {
    id: '88',
    anime: 'Future Boy Conan',
    year: '1978',
    name: 'Umasou',
    info: 'Umasou is Jimsy\'s piglet, "unmasou" which means "Look Delicious" in Japan.',
    img: '8_9',
    game: false,
  },
  {
    id: '89',
    anime: 'Future Boy Conan',
    year: '1978',
    name: 'Orlo',
    info: 'The coward and the traitor of the High Harbor, he follows the Industria and has an evil plot to become a leader of High Habor then he gives a demand to everyone to give up Industria.',
    img: '8_10',
    game: false,
  },
  // новые 10 аниме
  {
    id: '90',
    anime: 'Ni no Kuni',
    year: '2010',
    name: 'Rashaad',
    info: 'Great sage, Father Esther. In the ordinary world, mechanic Rusty.',
    img: '9_1',
    game: false,
  },
  {
    id: '91',
    anime: 'Ni no Kuni',
    year: '2010',
    name: 'Old Father Oak',
    info: 'Dweller of the Deep Dark Forest. Gave Oliver some new skills (fireball, heal, hit) and explained to him how to use the familiar.',
    img: '9_2',
    game: false,
  },
  {
    id: '92',
    anime: 'Ni no Kuni',
    year: '2010',
    name: 'Swaine (Jairo)',
    info: 'A thief joining Oliver. First encountered in Shipwreck Cove, where he received a bad reputation as a thief and stole an alchemical cauldron, which he later gave for no reason. Actually a Gascon, the eldest son of the former Emperor Khamelin and brother of Marcassin. He ran away from home in spite of his father, but still deeply loves both him and his brother. Extremely dislikes talking about his past.',
    img: '9_3',
    game: false,
  },
  {
    id: '93',
    anime: 'Ni no Kuni',
    year: '2010',
    name: 'Tengri',
    info: 'The dragon who helped Oliver and company after meeting with the hijackers at Skull Peak.',
    img: '9_4',
    game: false,
  },
  {
    id: '94',
    anime: 'Ni no Kuni',
    year: '2010',
    name: 'Timmy Toldrum',
    info: 'Mrs. Leila\'s cat in Motovilla. King Tom in the real world.',
    img: '9_5',
    game: false,
  },
  {
    id: '95',
    anime: 'Ni no Kuni',
    year: '2010',
    name: 'Philip (Mark)',
    info: 'A resident of Motoville and Oliver\'s best friend. A fan of cars, his biggest dream is to create the fastest and best car in the world.',
    img: '9_6',
    game: false,
  },
  {
    id: '96',
    anime: 'Ni no Kuni',
    year: '2010',
    name: 'Shadar (Executor)',
    info: 'Also known as the Dark Genie or Executor. An evil wizard who has the right to interfere with the soul of a person and is able to put him in the husk of corruption and vices, overwhelm him with negative emotions. Because of the powers given to him, people are afraid of him.',
    img: '9_7',
    game: false,
  },
  {
    id: '97',
    anime: 'Ni no Kuni',
    year: '2010',
    name: 'Allie',
    info: 'Oliver\'s mother. Weak in health, caring. Her death serves as the catalyst for Oliver\'s journey to Ni no Kuni. Gave Oliver a doll that became Drippy. In another world - the Great Sage Alicia.',
    img: '9_8',
    game: false,
  },
  {
    id: '98',
    anime: 'Ni no Kuni',
    year: '2010',
    name: 'Esther (Maru)',
    info: 'The singer who joined Oliver. Daughter of the Great Sage Rashaad. Quick-tempered enough. In the real world - a shy girl named Myrtle who never leaves her room, always looking out the window.',
    img: '9_9',
    game: false,
  },
  {
    id: '99',
    anime: 'Ni no Kuni',
    year: '2010',
    name: 'Oliver',
    info: 'The main character. He lives a joyful life until his mother suddenly dies, preventing him from drowning. After her death, Oliver cries over the stuffed toy, and his tears give this toy life. Following Drippy (a revived toy), he goes to the world of Ni no Kuni in search of his mother.',
    img: '9_10',
    game: false,
  },
];

export default date;
